








import { Component, Vue } from 'vue-property-decorator'
import pages from '@/constants/pages'

@Component({})
export default class RestartButton extends Vue {
  protected restart () {
    this.$store.dispatch('reset')
    this.$router.push(pages.MAIN_PATH)
  }
}
